import React, {useState} from 'react';
import {Glum} from '../../../puddleglum';
import {
	Button,
	FormControl,
	FormErrorMessage,
	FormLabel,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from 'components/ui/chakra';
import ProviderBookingController from 'puddleglum/api/providers/ProviderBookingController';

interface Props {
	bookingRequest: Glum.Models.BookingRequest | undefined;
	onCanceled: () => void;
	onClose: () => void;
}

const CancelBookingRequestModal = ({bookingRequest, onCanceled, onClose}: Props) => {
	const [reason, setReason] = useState('');
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const handleClose = () => {
		setReason('');
		setError('');
		onClose();
	};

	const handleConfirm = async () => {
		if (!reason.trim()) {
			setError('Please enter a reason for the cancellation.');
			return;
		}
		if (!bookingRequest) return;

		setIsLoading(true);
		try {
			await ProviderBookingController.update(bookingRequest.id, {
				location_id: Number(bookingRequest.location_id),
				...(bookingRequest.starts_at ? {starts_at: String(bookingRequest.starts_at)} : {}),
				status: 'canceled',
				...(bookingRequest.provider_id
					? {provider_id: Number(bookingRequest.provider_id)}
					: {}),
				cancel_reason: reason,
			});
			setReason('');
			setError('');
			onCanceled();
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Modal isOpen={!!bookingRequest} onClose={handleClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Cancel this booking request?</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<FormControl isInvalid={!!error}>
						<FormLabel>Enter the cancellation reason.</FormLabel>
						<Input
							value={reason}
							onChange={(e) => setReason(e.target.value)}
							placeholder='Reason'
							maxLength={255}
							autoFocus
						/>
						<FormErrorMessage>{error}</FormErrorMessage>
					</FormControl>
				</ModalBody>
				<ModalFooter gap={2}>
					<Button variant='outline' onClick={handleClose} disabled={isLoading}>
						Nevermind
					</Button>
					<Button colorScheme='red' onClick={handleConfirm} isLoading={isLoading}>
						Cancel Booking
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default CancelBookingRequestModal;
